import { Row, Col, H1 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const Container = styled.div`
  position:relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding:30px;
  max-width: 60%;
  background-color: #fff;
  box-shadow: 20px 12px 30px rgba(0, 0, 0, 0.3);
  text-align:center;
  border-top-left-radius:50px;
  border-bottom-right-radius:50px;
  margin-top:-80px;
  z-index:1;
  overflow:hidden;

  @media (min-width: 2000px) {
    max-width:1366px;
  }
`

const Title = styled(H1)`
  font-size: 42px;  
  color: #3e4d72;
  margin-bottom: 0;
  font-weight:800;
  line-height:1.2;
  width:100%;

  ${mq.below('sm')} {
    font-size: 32px;
  }
`

const Subtitle = styled.h3`
  font-size: 24px;
  line-height: 1.2;
  color: #3e4d72;
  margin: 0 0 30px 0;
  font-weight: 700;
  width:100%;
`
const SliderItem = styled.div`
  a {
  display:block;
    ${Image} {
      box-sizing: border-box;
      display: block;
      max-width: 100%;
      width:auto;
      height:auto;
      padding:0 15px;
      img {
        max-width: 100%;
        height:auto;
      }
    }
  }
`

const WorkForCompanies = props => {
  const slides = props.data.items
    ? props.data.items
    : [
        {
          image: props.data.image,
          title: props.data.title,
          link: props.data.link,
        }
      ]

  const numSlides = slides.length

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 5500, min: 1200 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }


  return (
    <Container>
      <Row>
        <Col>
          <Title>{props.data.title}</Title>
          <Subtitle>{props.data.subtitle}</Subtitle>
        </Col>
      </Row>

      <Carousel  index={props.index} numSlides={numSlides} responsive={responsive} infinite={true} autoPlay={true} arrows={false} autoPlaySpeed={10000}>
        {slides.map((slide, index) => (
          <SliderItem numSlides={numSlides} key={'slide-' + index} isActive={props.index === index} >
            <a href={slide.link} target="_blank">
                {slide?.image?.imgixImageWp?.fixed && (
                    <Image
                      fixed={{ ...slide.image.imgixImageWp.fixed }}
                      title={slide.title}
                    />
                )}
            </a>
          </SliderItem>
        ))}
      </Carousel>
    </Container>
  )
}

export default WorkForCompanies
